import React, { useEffect, useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
type Announcement = {
  address: string;
  schedule: string;
};
const announcements: Announcement[] = [{
  address: "18 Harbour Isle Dr #102",
  schedule: "Open House · Sept 19 · 1:00–4:00 PM ET"
}, {
  address: "20 Harbour Isle Dr W #106",
  schedule: "Open House · Sept 19 · 1:00–4:00 PM ET"
}];
export function OpenHouseAnnouncement() {
  const [activeIndex, setActiveIndex] = useState(0);
  const prefersReducedMotion = useReducedMotion();
  useEffect(() => {
    if (prefersReducedMotion) {
      return undefined;
    }
    const interval = window.setInterval(() => {
      setActiveIndex(index => (index + 1) % announcements.length);
    }, 4800);
    return () => window.clearInterval(interval);
  }, [prefersReducedMotion]);
  const announcement = announcements[activeIndex];
  return <aside className="relative overflow-hidden border-b border-amber-200/35 bg-amber-100 px-5 py-3 text-stone-950 sm:px-10 lg:px-14" aria-label="Open house announcements" data-id="element-42" data-mp="2ahx5x9ehxh5y">
      {!prefersReducedMotion && <motion.div className="pointer-events-none absolute inset-y-0 w-32 -skew-x-12 bg-sky-50" aria-hidden="true" initial={{
      x: "-25vw",
      opacity: 0
    }} animate={{
      x: ["-25vw", "-25vw", "120vw", "120vw"],
      opacity: [0, 0, 0.28, 0]
    }} transition={{
      duration: 6,
      repeat: Infinity,
      ease: "easeInOut",
      times: [0, 0.12, 0.35, 1]
    }} data-id="element-43" data-mp="1xw79wk8j3usm" />}
      <div className="relative mx-auto flex w-full max-w-7xl items-center justify-center gap-3" aria-live="polite" data-id="element-44" data-mp="1f4egwptgm9kw">
        <span className="hidden shrink-0 text-xs font-bold uppercase tracking-[0.16em] text-amber-900 sm:inline" data-id="element-45" data-mp="1tx85r1umg228">Featured</span>
        <motion.div key={activeIndex} className="min-w-0 text-center" initial={prefersReducedMotion ? false : {
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.2,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-46" data-mp="11ekpq0uhfd80">
          <p className="text-sm font-bold leading-5 sm:inline sm:text-base" data-id="element-47" data-mp="1q5qnr0wl3ifg">{announcement.address}</p>
          <p className="text-xs font-semibold leading-5 text-amber-900 sm:ml-3 sm:inline sm:text-sm" data-id="element-48" data-mp="1uwqo6g4wwimp">{announcement.schedule}</p>
        </motion.div>
      </div>
    </aside>;
}